import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
function useDebouncedValue(value, t0) {
  const $ = _c(4);
  const delay = t0 === undefined ? 100 : t0;
  const [throttledValue, setThrottledValue] = useState(value);
  let t1;
  let t2;
  if ($[0] !== delay || $[1] !== value) {
    t1 = () => {
      const timeout = setTimeout(() => setThrottledValue(value), delay);
      return () => clearTimeout(timeout);
    };
    t2 = [value, delay];
    $[0] = delay;
    $[1] = value;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (delay <= 0) {
    return value;
  }
  return throttledValue;
}
export default useDebouncedValue;